import { render, staticRenderFns } from "./PaymentOrdersCap.vue?vue&type=template&id=5cc6471c&scoped=true&"
import script from "./PaymentOrdersCap.vue?vue&type=script&lang=js&"
export * from "./PaymentOrdersCap.vue?vue&type=script&lang=js&"
import style0 from "./PaymentOrdersCap.vue?vue&type=style&index=0&id=5cc6471c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc6471c",
  null
  
)

export default component.exports